// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_7s-4";
export var collapsed = "_7s-1";
export var headerBar = "_7s-0";
export var leftHeaderContent = "_7s-3";
export var subjectContainer = "_7s-2";